import React, { useEffect, useState } from 'react';

import GlobalFont from './App.styled';

import './fonts.css';

import { NavBar } from './components/NavBar/NavBar';
import Waveform from './components/Waveform/Waveform';
import Modal from './components/Modal/Modal';
import { ProjectPresentation } from './components/ProjectPresentation/ProjectPresentation';
import { TrackPresentation } from './components/TrackPresentation/TrackPresentation';

function App() {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [idChunkClicked, setIdChunkClicked] = useState<number>();

  const handleShowModal = (newIdChunk: number) => {
    setShowModal(!showModal);
    setIdChunkClicked(newIdChunk);
    console.log(showModal, 'Id ', newIdChunk);
  };

  useEffect(() => {
    if (showModal) {
      //document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  return (
    <>
      <GlobalFont />
      <NavBar />
      <ProjectPresentation onClick={handleShowModal} />
      <Waveform />
      {showModal && (
        <Modal onClick={handleShowModal} idChunk={idChunkClicked} />
      )}
      <TrackPresentation />
      <div style={{ height: '1000px' }}></div>
    </>
  );
}

export default App;
